export type TournamentTeamRow = {
  tournamentId: unknown;
  status?: unknown;
  tournamentName?: string;
};

function asRows(value: unknown): Record<string, unknown>[] {
  if (!Array.isArray(value)) return [];
  return value.filter((row) => row && typeof row === "object") as Record<string, unknown>[];
}

function idsEqual(left: unknown, right: unknown): boolean {
  if (left == null || right == null) return false;
  try {
    return BigInt(left as string | number | bigint) === BigInt(right as string | number | bigint);
  } catch {
    return String(left) === String(right);
  }
}

export function filledTournamentTeams(value: unknown): TournamentTeamRow[] {
  return asRows(value)
    .filter((row) => row.tournamentId != null && row.tournamentId !== "")
    .map((row) => ({
      tournamentId: row.tournamentId,
      status: row.status ?? 1,
      tournamentName: row.tournamentName == null ? undefined : String(row.tournamentName),
    }));
}

export function buildAddTournamentTeams(values: Record<string, unknown>): {
  tournamentId: unknown;
  status: number;
}[] {
  return filledTournamentTeams(values.tournamentTeams).map((row) => ({
    tournamentId: row.tournamentId,
    status: 1,
  }));
}

export function buildTournamentTeamsPatch(
  values: Record<string, unknown>,
  baseline: Record<string, unknown>,
): Record<string, unknown> | null {
  const current = filledTournamentTeams(values.tournamentTeams);
  const previous = filledTournamentTeams(baseline.tournamentTeams);
  const tournamentTeams: { tournamentId: unknown; status: number }[] = [];

  for (const row of previous) {
    const stillAssigned = current.some((item) => idsEqual(item.tournamentId, row.tournamentId));
    if (!stillAssigned) tournamentTeams.push({ tournamentId: row.tournamentId, status: 0 });
  }

  for (const row of current) {
    const alreadyAssigned = previous.some((item) => idsEqual(item.tournamentId, row.tournamentId));
    if (!alreadyAssigned) tournamentTeams.push({ tournamentId: row.tournamentId, status: 1 });
  }

  return tournamentTeams.length ? { tournamentTeams } : null;
}

export function syncTournamentTeamsBaseline(values: Record<string, unknown>, baseline: Record<string, unknown>) {
  baseline.tournamentTeams = JSON.parse(JSON.stringify(values.tournamentTeams ?? []));
}
